import { colorBackgroundCollapseSelected } from "../../../utils/setting";
export const tablecellStyles = (theme) => ({
  alignCenter: {
    textAlign: "center",
  },
  alignLeft: {
    textAlign: "left",
  },
  smallWidth: {
    width: "2%",
  },
  normal: {},
  statusHead: {
    width: "13%",
    textAlign: "center",
  },
  logoMasspa: {
    width: "1.2rem",
  },
  customHeader: {
    // marginLeft: '5rem'
  },
});
export const styles = (theme) => ({
  // textField: {
  //     width: '100%'
  // },
  tableCellInCollapes: {
    borderBottom: "none",
  },
  frameTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  iconGender: {
    width: "1rem",
    marginLeft: "0.5rem",
  },
  collapseSelected: {
    backgroundColor: colorBackgroundCollapseSelected,
  },
  list: {
    width: "20rem",
    padding: "1.5rem",
  },
  button: {
    width: "-webkit-fill-available",
  },
  buttonOnRow: {
    margin: "0.2rem",
    width: "-webkit-fill-available",
  },
  // fullList: {
  //     width: 'auto',
  // },
  infoRecord: {
    fontSize: "0.8rem",
    color: "#546e7a",
    marginTop: "1.6rem",
  },
  headerFilter: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "1rem",
  },
  nameTitle: {
    fontWeight: "bold",
  },
  containerImageRound: {
    position: "relative",
    borderRadius: "50%",
    // margin: 'auto',
    width: "3rem",
    height: "3rem",
    // boxShadow :'0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);',
    backgroundSize: "cover",
    backgroundPosition: "center",
    cursor: "pointer",
    objectFit: "cover",
  },
  rightCard: {
    // width: '4rem',
    marginLeft: "1rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  containerIconMasspa: {
    top: 0,
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    width: "1rem",
    height: "1rem",
    marginTop: "2rem",
    marginLeft: "2rem",
    // border: '4px solid #fff',
    backgroundColor: " #ff513f",
    borderRadius: "50%",
    cursor: "pointer",
  },
  keyName: {
    marginRight: "0.3rem",
    // fontWeight: 'bold'
  },
  iconMasspa: {
    width: "1.3rem",
  },
  image: {
    objectFit: "contain",
    width: "45vw",
    height: "25vw",
    // cursor: 'pointer',
    backgroundSize: "cover",
    backgroundPosition: "center",
    boxShadow:
      "0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)",
  },
  containerCard: {
    display: "flex",
    justifyContent: "flex-start",
    paddingBottom: "1rem",
    paddingTop: "1rem",
  },
  logoMasspa: {
    width: "1.2rem",
  },
  root: {
    width: "100%",
    // marginTop: theme.spacing(3),
    cursor: "pointer",
  },
  tableWrapper: {
    overflowX: "auto",
    position: "relative",
  },
  tableCellEdit: {
    borderBottom: "none",
  },
  // headerFillter: {
  //     padding: theme.spacing(2),
  //     paddingTop: theme.spacing(3)
  // },
  district: {
    textTransform: "capitalize",
  },
  city: {
    textTransform: "capitalize",
  },
  textCapitalize: {
    textTransform: "capitalize",
  },
  containerIcons: {
    display: "flex",
  },
  iconCopy: {
    fontSize: 20,
    cursor: "pointer",
    marginRight: 8,
  },
  Pagination: {
    display: "flex",
    justifyContent: "center",
  },
  iconEdit: {
    width: "16px",
    height: "16px",
    cursor: "pointer",
  },
});
export const edit = (theme) => ({
  textField: {
    // marginLeft: theme.spacing(1),
    // marginRight: theme.spacing(1),
    // width: `calc(100% - ${theme.spacing(2)}px)`
  },
  input: {},
  label: {
    fontWeight: 410,
  },
  chip: {
    margin: theme.spacing(1),
  },
  dense: {
    marginTop: 16,
  },
  labelTextField: {
    backgroundColor: "#fff",
  },
  button: {
    margin: theme.spacing(1),
    width: "100%",
    height: "40px",
    borderradius: "4px",
    boxShadow: "0 2px 5px 0 rgba(0, 0, 0, 0.5)",
  },
  formControl: {
    width: "100%",
    // margin: theme.spacing(1),
  },
  wrapButton: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    width: "100%",
    textAlign: "right",
  },
  wrapButtonReport: {
    marginRight: theme.spacing(2),
  },
  wrapButtonSave: {},
  containerImage: {
    position: "relative",
    borderRadius: "50%",
    margin: "auto",
    width: "10rem",
    height: "10rem",
    boxShadow:
      "0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);",
    backgroundSize: "cover",
    backgroundPosition: "center",
    cursor: "pointer",
  },
  camera: {
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    width: "2rem",
    height: "2rem",
    marginTop: "65%",
    marginLeft: "65%",
    border: "4px solid #fff",
    backgroundColor: " #ff513f",
    borderRadius: "50%",
  },
  iconCamera: {
    width: "1.3rem",
  },
  rootLabel: {
    fontSize: "1rem",
    // fontWeight: 'bold',
    // color: '#292f48 !important',
    whiteSpace: "nowrap",
  },
  disabledRootLabel: {
    // fontSize: '1rem',
    // fontWeight: 'bold',
    // color: '#292f48 !important',
    whiteSpace: "nowrap",
  },
  containerItems: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  colorButtonViewReport: {
    backgroundColor: "#292f48",
    "&:hover": {
      backgroundColor: "black",
    },
  },
  colorButtonSave: {
    backgroundColor: "#ff513f",
  },
  multilinePadding: {
    padding: "6px 0 8px",
  },
  editFormContainer: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    padding: theme.spacing(3),
  },
  infoBox: {
    marginTop: "1rem",
  },
});
